import { ABOUT_CIRCLE_V4_PATH } from "@circle-react/components/NewVersionOptIn/constants";
import type { HeaderNavigationLinkItemKind } from "@circle-react/lib/queries/headerNavigationLinks";

export const HEADER_V2_1_DISABLED_ROUTES = [
  "/live/$roomSlug/not_supported",
  "/live/$roomSlug/record",
  "/live/$roomSlug/mobile",
  "/live/$roomSlug/public",
  "/live/$roomSlug",
  ABOUT_CIRCLE_V4_PATH,
] as const;

type ManagedHeaderLinkKind = Exclude<HeaderNavigationLinkItemKind, "custom">;

export const HEADER_V3_ROUTES = {
  members: "/members",
  events: "/events",
  courses: "/courses",
  leaderboard: "/leaderboard",
  home: "/feed",
  newsletter_homepage: "/newsletter",
} as const satisfies Record<ManagedHeaderLinkKind, string>;

// Site pages, not Circle app routes. A new system page kind belongs here so
// header, sidebar, and edit-link behavior pick it up together. The route value
// is the public path, which does not have to match the kind name.
const SYSTEM_PAGE_KINDS = [
  "newsletter_homepage",
] as const satisfies readonly (keyof typeof HEADER_V3_ROUTES)[];

export type SystemPageKind = (typeof SYSTEM_PAGE_KINDS)[number];

export const isSystemPageKind = (
  kind: string | undefined,
): kind is SystemPageKind =>
  kind != null &&
  SYSTEM_PAGE_KINDS.some(systemPageKind => systemPageKind === kind);

export const shouldRenderHeaderLinkAsAnchor = (
  kind: string,
  linkTo: string,
  renderAsAnchor = false,
) =>
  renderAsAnchor ||
  kind === "custom" ||
  isSystemPageKind(kind) ||
  (kind === "home" && linkTo === "/");
